import { useQuery, useMutation, useQueryClient, keepPreviousData } from "@tanstack/react-query";

import {
  getLeads,
  getLead,
  exportLeads,
  resendLead,
  resetLeadStatus,
} from "../../api/leads/lead.api.js";

export const useLeadsQuery = ({
  page = 1,
  page_size = 10,
  category,
  property_id,
  agent_id,
  source,
  intent,
  sort = "latest",
} = {}) => {
  return useQuery({
    queryKey: ["leads", page, page_size, category, property_id, agent_id, source, intent, sort],
    queryFn: () =>
      getLeads({ page, page_size, category, property_id, agent_id, source, intent, sort }),
    placeholderData: keepPreviousData,
  });
};



export const useLeadQuery = (id) => {
  return useQuery({
    queryKey: ["leads", id],
    queryFn: () => getLead(id),
    enabled: !!id,
  });
};

export const useExportLeads = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: exportLeads,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
  });
};

export const useResendLead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resendLead,
    onSuccess: async () => {
      await new Promise((resolve) =>
        setTimeout(resolve, 1000)
      );
    
      queryClient.invalidateQueries({
        queryKey: ["leads"],
      });
    }
  });
};



export const useResetLeadStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resetLeadStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
  });
};
